import React from 'react';

import Header from '../Header';
import Footer from '../Footer';

import './index.scss';

const Layout: React.FC = ({ children }) => {
  return (
    <>
      <title>Web3 Messaging</title>
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default Layout;
